import { IconButton, Spacer, SvgDownload, SvgTrash } from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  DESKTOP_MIN_WIDTH,
  LARGE_TABLET_MIN_WIDTH,
  SMALL_DESKTOP_MAX_WIDTH,
} from 'constants/breakpoints';
import { DOWNLOAD } from 'constants/menuOptions';
import { CONFIRM_DELETE_ITEM_MODAL } from 'constants/modalTypes';
import { LOOM_BARE_URI, MY_VIDEOS_PAGE } from 'constants/routes';
import { startDownload } from 'creators/header';
import { selectAnonCreatorMode } from 'selectors/shareVideo';

import { useUserInSameWorkspaceAsItem } from 'hooks/workspace';

import OverflowMenu from '../overflow-menu';
import ShareButtonsWrapper from '../share-buttons';
import ViewerInsightsButton from '../viewer-insights/button';
import ViewerInsightsForNonWorkspaceViewers from '../viewer-insights/simple';

import HeaderPortal from 'components/layout/header/portal';
import MediaQuery from 'components/media-query';

import styles from './styles.module.less';

export default ({
  downloadUrl,
  user,
  video,
  currentUserIsOwner,
  videoIsTeamShared,
  isLoggedIn,
}) => {
  const dispatch = useDispatch();
  const anonCreatorMode = useSelector(selectAnonCreatorMode);

  const downloadName = `${video.name || video.id}.mp4`;

  const downloadVideo = () => {
    dispatch(
      startDownload({
        url: downloadUrl,
        name: downloadName,
        opts: {
          video_id: video.id,
          is_owner: video.current_user_is_owner,
        },
      })
    );
  };

  const viewerInMatchingWorkspace = useUserInSameWorkspaceAsItem(video);

  const downloadProps = {
    altText: DOWNLOAD,
    icon: <SvgDownload />,
    onClick: downloadVideo,
    isDisabled: !downloadUrl,
  };

  return (
    <HeaderPortal>
      <MediaQuery query={`(min-width: ${LARGE_TABLET_MIN_WIDTH}px)`}>
        <div className="flex shrink:0">
          <div
            className={`flex ml:auto ${styles.wrapper} pr:medium borderRight`}
          >
            {/* only show on screen sizes where we show the right panel */}
            <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
              <MediaQuery query={`(min-width: ${SMALL_DESKTOP_MAX_WIDTH}px)`}>
                {viewerInMatchingWorkspace || anonCreatorMode ? (
                  <ViewerInsightsButton
                    user={user}
                    showAvatars={viewerInMatchingWorkspace}
                  />
                ) : (
                  <ViewerInsightsForNonWorkspaceViewers />
                )}
              </MediaQuery>
              {!isLoggedIn && (
                <MediaQuery query={`(min-width: ${DESKTOP_MIN_WIDTH}px)`}>
                  <div className="flex items:center">
                    <Spacer right="medium">
                      <IconButton {...downloadProps} />
                    </Spacer>
                  </div>
                </MediaQuery>
              )}
              <ShareButtonsWrapper
                className="relative"
                currentUserIsOwner={currentUserIsOwner}
                shareModalShouldOpenAsDropdown
                user={user}
                video={video}
                videoIsTeamShared={videoIsTeamShared}
              />
              <div className="ml:small flex items:center">
                {!anonCreatorMode && (
                  <OverflowMenu video={video} isLoggedIn={isLoggedIn} />
                )}
                {anonCreatorMode && (
                  <IconButton
                    icon={<SvgTrash />}
                    onClick={() => {
                      dispatch(
                        openModal(CONFIRM_DELETE_ITEM_MODAL, {
                          videos: [video],
                          redirectUrl: isLoggedIn
                            ? `https://${LOOM_BARE_URI}${MY_VIDEOS_PAGE}`
                            : `https://${LOOM_BARE_URI}`,
                        })
                      );
                    }}
                  />
                )}
              </div>
            </MediaQuery>
          </div>
        </div>
      </MediaQuery>
    </HeaderPortal>
  );
};
